import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
  Spinner,
} from "reactstrap";
import ReeValidate from "ree-validate";
import { Link } from "react-router-dom";
import { errorAlert } from "../../../web/store/alertActions";
import { validateWorkspace } from "../../store/loginActions";
import { clientHost, httpHost, websiteUrl } from "../../../../config/config";

class ValidateWorkspace extends Component {
  constructor(props) {
    super(props);

    this.validator = new ReeValidate({
      name: "required",
    });
    this.timeout = null;
    this.state = {
      isSubmiting: false,
      formData: {
        name: "",
      },
      errors: this.validator.errors,
      isDisable: true,
    };
  }

  componentDidMount() {
    if (
      this.props.isAuthenticated &&
      localStorage.getItem("from") !== "reset"
    ) {
      this.props.history.push("/dashboard");
    }
  }

  handleChange = (e) => {
    this.setErrors();
    setTimeout(() => {
      this.setDisabled();
    }, 10);
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      formData: { ...this.state.formData, [name]: value },
    });
    this.validator.validate(name, value).then(() => {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.timeout = null;
        this.setErrors();
      }, 1000);
    });
  };

  setErrors = () => {
    const { errors } = this.validator;
    this.setState({ errors });
  };

  setDisabled = () => {
    this.setState({ isDisable: this.state.errors.items.length > 0 });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { formData } = this.state;
    const { errors } = this.validator;
    this.validator.validateAll(formData).then((success) => {
      if (success) {
        this.setState({ isSubmiting: true });
        const payloadData = new FormData();
        payloadData.append("name", this.state.formData.name);
        this.props
          .validateWorkspace(payloadData)
          .then(() => {
            window.location =
              httpHost + this.state.formData.name + "." + clientHost;
          })
          .catch((err) => {
            this.setState({ isSubmiting: false });
            this.props.errorAlert("We couldn’t find your workspace!");
          });
      } else {
        this.setState({ errors });
      }
    });
  };

  render() {
    return (
      <main>
        <Row className="split-screen"></Row>
        <Row>
          <Col sm="4"></Col>
          <Col sm="4" className="pd-10">
            <Row>
              <Col sm="4"></Col>
              <Col sm="4">
                <a href={websiteUrl} alt="website">
                  <img
                    src={"/assets/consolve-icon.png"}
                    alt="workspace"
                    className="logo-img w-50"
                  />
                </a>
              </Col>
              <Col sm="4"></Col>
            </Row>
          </Col>
          <Col sm="4"></Col>
        </Row>
        <br />
        <Row>
          <Col sm="4"></Col>
          <Col sm="4" className="pd-10">
            <Card className="color-bg">
              <CardBody className="validate-workspace-tag">
                <CardTitle>Sign in to your workspace</CardTitle>
                <CardSubtitle>Enter your workspace Consolve URL.</CardSubtitle>
                <div className="main-card">
                  <form onSubmit={this.handleSubmit}>
                    <InputGroup>
                      <Input
                        type="text"
                        name="name"
                        id="name"
                        onChange={this.handleChange}
                        placeholder="your-workspace-url"
                      />
                      <InputGroupAddon
                        className="append-custom"
                        addonType="append"
                      >
                        <InputGroupText>.consolve.com</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                    <br />
                    <Button
                      className="btn-custom"
                      color="primary"
                      size="lg"
                      block
                      disabled={this.state.isDisable}
                    >
                      Continue {this.state.isSubmiting && <Spinner size="sm" />}
                    </Button>
                    <br />
                    <div className="links-div">
                      <span>Don’t know your workspace url?</span>{" "}
                      <Link to={"/find-workspace"} className="card-links">
                        Find your workspace
                      </Link>
                    </div>
                  </form>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col sm="4"></Col>
        </Row>
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    validateWorkspace: (data) => {
      return dispatch(validateWorkspace(data));
    },
    errorAlert: (data) => {
      return dispatch(errorAlert(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateWorkspace);
